module.exports = __webpack_public_path__ + "img/stock1.e0b171ce.png";